import classNames from 'classnames';
import * as React from 'react';

import css from './SwitchContainerButton.module.scss';

interface Props {
  name: string;
  id: string;
  checked?: boolean;
  defaultChecked?: boolean;
  value?: string;
  label?: string;
  onChange?: (e: React.ChangeEvent) => void;
}

const SwitchContainerButton = ({ label, ...radioProps }: Props) => {
  const classes = classNames(css.SwitchContainerButton);

  return (
    <span className={classes}>
      <input
        type="radio"
        className={classNames(css.SwitchContainerButton__Input, {
          [css.isSelected]: radioProps.checked,
        })}
        {...radioProps}
      />
      <label
        className={css.SwitchContainerButton__Label}
        htmlFor={radioProps.id}
      >
        <span>{label || radioProps.value}</span>
      </label>
    </span>
  );
};

export default SwitchContainerButton;
